import styled from "styled-components";

export const SelectorButtton = styled.button`
  font-family: "BiryaniBold";
  width: 25vw;
  height: 30px;
  cursor: pointer;
  color: white;
  border: none;
  border-radius: 10px;
  background-color: #00cc66;
  text-transform: uppercase;
  margin-bottom: 8px;
  font-size: 12px;
  padding: 6.5px;

  &:hover {
    background-color: #006633;
  }

  :active {
    background-color: #003300;
  }
  @media only screen and (max-width: 414px) {
    width: 75vw;
    margin-left: -16px;
  }
`;
export const SelectorTitle = styled.div`
  color: white;
  text-transform: uppercase;
  font-size: 9px;
  font-family: "BiryaniBold";
  margin-bottom: -3px;
  text-align: center;
`;
